import { ExternalIdType, getPaymentAttemptsByExternalId } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { PaymentAttempts } from '@/components/modules/PaymentAttempts/shared/PaymentAttempts';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const LoanPaymentAttempts = () => {
  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: paymentAttempts, loading } = useCache(getPaymentAttemptsByExternalId, {
    externalId: loanId,
    type: ExternalIdType.LOAN,
  });

  useSetPageLoadingWhenRequesting('PAYMENT_ATTEMPTS', [loading]);

  return (
    <>
      <div className={'appear-anim'}>
        {paymentAttempts ? (
          <PaymentAttempts paymentAttempts={paymentAttempts} />
        ) : (
          <PendingDataWarning type={PendingDataType.PAYMENT_ATTEMPTS} />
        )}
      </div>
    </>
  );
};

export const LoanPaymentAttemptsModule = withPermissionsModule(LoanPaymentAttempts);
